import http from '../const/http-common'

const runQuery = (queryInfo) => {
  return http.post("/v1/user/sql-geneartor/query", queryInfo);
};
const testQuery = (queryInfo) => {
  console.log(queryInfo);
  return http.post("/testquery", queryInfo);
};

const QueryService = {
  runQuery,
  testQuery,
};

export default QueryService;
